import type { AxiosResponse } from 'axios';

/**
 * Trigger a browser download from an axios response containing a Blob.
 *
 * Reads the filename from the `Content-Disposition` header when present,
 * otherwise falls back to `fallbackFilename`. Backends should always set
 * `Content-Disposition: attachment; filename="..."` so the user gets a
 * meaningful filename.
 */
export function downloadResponseAsFile<T>(
  response: AxiosResponse<T>,
  fallbackFilename: string
): void {
  const disposition = response.headers?.['content-disposition'];
  const match =
    typeof disposition === 'string'
      ? disposition.match(/filename="?([^";]+)"?/)
      : null;
  const filename = match?.[1] || fallbackFilename;

  const data = response.data as unknown;
  const blob = data instanceof Blob ? data : new Blob([data as BlobPart]);

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
